<template>
  <p v-html="attention" />
</template>

<script>
import {defineComponent, computed} from 'vue'

export default defineComponent({
  name: 'AttentionTextParts',
  components: {},
  props: {
    type: {
      type: String,
      default: 'new',
    },
  },
  setup(props) {
    const attention = computed(() => {
      if (props.type === 'new') {
        return '※新車はご成約により在庫が無い場合がございます。<br>※システムの都合上、表示が実際の排気量と異なる場合や、システムの不具合により現金販売価格が正しく表示されていない場合がございます。<br>詳しくは各店舗までお問い合わせください。'
      } else if (props.type === 'used' || props.type === 'unused') {
        return '※中古車はご成約により在庫が無い場合がございます。<br>※システムの不具合により現金販売価格が正しく表示されていない場合がございます。<br>詳しくは各店舗までお問い合わせください。'
      } else if (props.type === 'test') {
        return '※試乗車は点検・貸出等でご試乗できない場合がございます。<br>※最新情報・ご試乗につきましては各店舗までお問い合わせください。'
      } else {
        return ''
      }
    })
    return {
      attention
    }
  },
})

</script>